import { Survey, SurveyQuestion } from 'types/survey';
import { Answer } from 'types/surveyResponse';
import { filterDependent } from 'utils/survey';
import { Selector } from 'components/ui/Selector';
import { useSurveyTranslation } from 'hooks/useSurveyTranslation';
import styles from './SelectorQuestion.module.scss';

interface IProps {
  surveyDefinition: Survey;
  question: SurveyQuestion;
  answer: Answer;
  siblingAnswers: Answer[];
  onChange: (answer: Answer) => void;
}

export const SelectorQuestion = ({ surveyDefinition, question, answer, siblingAnswers, onChange }: IProps) => {
  const ts = useSurveyTranslation(surveyDefinition);

  return (
    <div
      className={question.input === 'selector-fullwidth' ? styles.selectorQuestionFullWidth : styles.selectorQuestion}>
      {question.options
        ?.filter(o => filterDependent(o, siblingAnswers))
        .map((o) => (
        <Selector
          key={o.value}
          label={ts(o.name)}
          isChecked={o.value === answer.value}
          onSelect={() => onChange({ ...answer, value: o.value !== answer.value ? o.value : null })}
        />
      ))}
    </div>
  );
};
